import { isEmpty, startCase } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
const HomeLeft = ({ eventName, gameType, seriesName }) => {
  const { type } = useParams();
  const stableTab = useMemo(() => type, [type]);
  const [list, setList] = useState([]);
  const leagueData = async () => {
    const { status, data } = await apiGet(apiPath.seriesList, {
      gameType: stableTab,
    });
    if (data?.success) {
      setList(data?.results);
    }
  };
  useEffect(() => {
    if (!isEmpty(stableTab)) {
      leagueData();
    }
  }, [stableTab]);
  return (
    <div className="col-left" style={{}}>
      <div
        className="sub_path"
        id="subMenu"
        style={{ height: "calc(100% - 0px)" }}
      >
        <div className="path">Sports</div>
        {isEmpty(eventName) && isEmpty(gameType) ? (
          <ul id="listBoard" className="menu-list">
            {!isEmpty(type) ? (
              <li id="allSports" className="path-last">
                <Link to="/sports-sky">All Sports</Link>
              </li>
            ) : (
              <div id="sportStage" style={{ display: "block" }}>
                <li
                  id="naviMenu_4"
                  className="listBoard"
                  style={{ display: "list-item" }}
                  eventtype={4}
                  eventname="CRICKET"
                  title="CRICKET"
                >
                  <Link
                    to="/sports-sky/cricket"
                    id="name"
                    style={{ cursor: "pointer" }}
                  >
                    Cricket
                  </Link>
                </li>
                <li
                  id="naviMenu_1"
                  className="listBoard"
                  style={{ display: "list-item" }}
                  eventtype={1}
                  eventname="SOCCER"
                  title="SOCCER"
                >
                  <Link
                    to="/sports-sky/soccer"
                    id="name"
                    style={{ cursor: "pointer" }}
                  >
                    Soccer
                  </Link>
                </li>
                <li
                  id="naviMenu_2"
                  className="listBoard"
                  style={{ display: "list-item" }}
                  eventtype={2}
                  eventname="TENNIS"
                  title="TENNIS"
                >
                  <Link
                    to="/sports-sky/tennis"
                    id="name"
                    style={{ cursor: "pointer" }}
                  >
                    Tennis
                  </Link>
                </li>
              </div>
            )}
            {!isEmpty(type) && (
              <>
                <div className="path">{startCase(type)}</div>
                {list?.map((res) => {
                  return (
                    <ul id="ocerTopCompetitions">
                      <li className="menu-group-title">{res?.seriesName}</li>
                      {res?.matchList?.map((item) => {
                        return (
                          <li
                            id="naviMenu_12773026"
                            className="listBoard"
                            style={{ display: "list-item" }}
                          >
                            <Link
                              to={`/match-detail-sky/${item?.eventId}/${item?.marketId}`}
                              id="name"
                              style={{ cursor: "pointer" }}
                            >
                              {item?.eventName}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  );
                })}
              </>
            )}
          </ul>
        ) : (
          <ul id="listBoard" className="menu-list">
            <li id="allSports" className="path-last">
              <Link to="/sports-sky">All Sports</Link>
            </li>

            <div id="sportStage" style={{ display: "block" }}>
              <li
                id="naviMenu_4"
                className="listBoard"
                style={{ display: "list-item" }}
              >
                <Link
                  to={`/sports-sky/${gameType}`}
                  id="name"
                  style={{ cursor: "pointer" }}
                >
                  {startCase(gameType)}
                </Link>
              </li>
              <li
                id="naviMenu_1"
                className="listBoard"
                style={{ display: "list-item" }}
              >
                <Link
                  to={`/sports-sky/${gameType}`}
                  id="name"
                  style={{ cursor: "pointer" }}
                >
                  {startCase(seriesName)}
                </Link>
              </li>

              <li
                id="naviMenu_34952423"
                className="listBoard menu-select-head"
                style={{ display: "list-item" }}
              >
                <a id="name" style={{ cursor: "pointer" }}>
                  {eventName}
                </a>
              </li>
            </div>
          </ul>
        )}
      </div>
    </div>
  );
};

export default HomeLeft;
